import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products API
export const productsAPI = {
  getAll: (categoryId = null) => {
    const url = categoryId ? `${API}/products?category_id=${categoryId}` : `${API}/products`;
    return axios.get(url);
  },
  getById: (id) => axios.get(`${API}/products/${id}`),
  create: (data) => axios.post(`${API}/products`, data),
  update: (id, data) => axios.put(`${API}/products/${id}`, data),
  updateOrder: (id, displayOrder) => axios.put(`${API}/products/${id}/order`, null, { params: { display_order: displayOrder } }),
  delete: (id) => axios.delete(`${API}/products/${id}`),
};

// Categories API
export const categoriesAPI = {
  getAll: () => axios.get(`${API}/categories`),
  create: (data) => axios.post(`${API}/categories`, data),
  update: (id, data) => axios.put(`${API}/categories/${id}`, data),
  delete: (id) => axios.delete(`${API}/categories/${id}`),
};

// Contact API
export const contactAPI = {
  submit: (data) => axios.post(`${API}/contact`, data),
  getAll: (status = null) => {
    const url = status ? `${API}/contact?status=${status}` : `${API}/contact`;
    return axios.get(url);
  },
};

// Newsletter API
export const newsletterAPI = {
  subscribe: (email) => axios.post(`${API}/newsletter`, { email }),
  getAll: () => axios.get(`${API}/newsletter`),
};

// Image Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// Product Import API
export const importAPI = {
  importFromURL: (url) => axios.post(`${API}/import-product`, { url }),
  importBulk: (urls) => axios.post(`${API}/import-products-bulk`, urls),
};
